// extracted by mini-css-extract-plugin
export var subtitle = "_9n-2";
export var title = "_9n-0";
export var titleNoWrap = "_9n-1";